import { DEFAULT_LANGUAGE } from '@consts';
import { useTranslation } from 'react-i18next';

// HACK: the entire landing page (live page, preview, and editor — content and
// chrome alike) is currently locked to Polish until we add per-goal translations
// for user-authored values. Use this hook for every translation call under
// components/goals/goal-landing-page/. Grep for `useLandingPageTranslation`
// when it's time to remove the lock and split chrome back to the user's language.
export function useLandingPageTranslation() {
  return useTranslation(undefined, { lng: DEFAULT_LANGUAGE });
}
